import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  constructor(private httpClient: HttpClient,
    private router: Router,
    private sessionService: SessionService) {
  }

  private apiUrl: string = environment.api;

  get getAccessToken() {
    return localStorage.getItem('access-token');
  }

  get PasswordCheckhttpOptions() {
    return {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'ApiKey' : environment.apiProtectionKey,
          'productCode' : environment.productCode,
          // 'slug' : this.sessionService.ApiEnv.slug,
        })
    };
  }
  get httpOptionsOAuthProtection() {
    return {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'ApiKey' : environment.apiProtectionKey,
          'productCode' : environment.productCode,   
          'slug' : this.sessionService.ApiEnv.slug,
        })
    };
  }
  get httpOptions() {
    return {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.getAccessToken
          // 'Authorization': 'Basic ' + btoa(environment.username + ':' + environment.password)
          // 'Authorization': 'Basic ' + btoa(this.sessionService.ApiEnv.userName + ':' + this.sessionService.ApiEnv.password);
        })
    };
  }
  patchHttpOptions(ifMatchKey: string) {
    return {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.getAccessToken,
          // 'Authorization': 'Basic ' + btoa(environment.username + ':' + environment.password),
          // 'Authorization': 'Basic ' + btoa(this.sessionService.ApiEnv.userName + ':' + this.sessionService.ApiEnv.password);
          'If-Match': ifMatchKey
        })
    };
  }

  getApiUrl(endpoint: string) {
    // if(this.sessionService && this.sessionService.ApiEnv && this.sessionService.ApiEnv.api){
    //   this.apiUrl = this.sessionService.ApiEnv.api;

    // }
    // else{
    //   this.router.navigate(["/login"]);
    // }
    if (endpoint.includes('/companies')) {
      return this.apiUrl + endpoint;
    } else {
      return this.apiUrl + '/companies(' + this.sessionService.Company + ')' + endpoint;
    }
  }

  public get(endpoint: string) {
    return this.httpClient.get(this.getApiUrl(endpoint), this.httpOptions);
  }

  public post(endpoint: string, body: any) {
    delete body['index'];
    // body.mCreatedBy = '';
    // body.mModifieddBy = '';    
    return this.httpClient.post(this.getApiUrl(endpoint), body, this.httpOptions);
  }

  public put(endpoint: string, body: any) {
    delete body['index'];
    return this.httpClient.put(this.getApiUrl(endpoint), body, this.httpOptions);
  }

  public patch(endpoint: string, body: any) {
    delete body['index'];
    const ifMatchKey = "*";
    return this.httpClient.patch(this.getApiUrl(endpoint), body, this.patchHttpOptions(ifMatchKey));
  }

  public delete(endpoint: string) {
    return this.httpClient.delete(this.getApiUrl(endpoint), this.httpOptions);
  }
  public passwordCheck(body:any){
    return this.httpClient.post(environment.passwordCheckApi,body,this.PasswordCheckhttpOptions);
  }
  public getOAuth2Token() {
    // return this.httpClient.get(`${environment.oauthTokenApi}Auth/Token`);
    return this.httpClient.get(environment.oauthTokenApi,this.httpOptionsOAuthProtection);
  }
}
